{
  "repository": "n0lavar/cp_red_npc_generator",
  "commit": "dfd4c08c4295c3d34f11a6c75c4d3ae5792ef2a4",
  "root": "npc_generator_for_cp_red/src/cp_red_npc_generator",
  "paths": [
    "configs/ranks.json",
    "configs/roles.json",
    "configs/stats.json",
    "configs/skills.json",
    "configs/skill_specializations.json",
    "configs/weapon_skills.json",
    "configs/lifepath.json",
    "configs/nationality_weights.json",
    "configs/description_prompt.md",
    "configs/items/ammo.json",
    "configs/items/armor.json",
    "configs/items/drugs.json",
    "configs/items/equipment.json",
    "configs/items/junk.json",
    "configs/items/weapon.json",
    "configs/items/cyberware/borgware.json",
    "configs/items/cyberware/cyberarm.json",
    "configs/items/cyberware/cyberaudio.json",
    "configs/items/cyberware/cyberfingers.json",
    "configs/items/cyberware/cyberleg.json",
    "configs/items/cyberware/cyberlimb.json",
    "configs/items/cyberware/cyberopticks.json",
    "configs/items/cyberware/default_containers.json",
    "configs/items/cyberware/external_cyberware.json",
    "configs/items/cyberware/fashionware.json",
    "configs/items/cyberware/internal_cyberware.json",
    "configs/items/cyberware/neuralware.json"
  ]
}
